const topDestinationSlugs = [
  {
    slug: 'Fort-Lauderdale--FL--United-States',
    title: 'slug--Fort-Lauderdale--FL--United-States_title',
    subtitle: 'slug--Fort-Lauderdale--FL--United-States_subtitle',
  },
  {
    slug: 'The-Bahamas',
    title: 'slug--The-Bahamas_title',
  },
  {
    slug: 'Charleston--SC--United-States',
    title: 'slug--Charleston--SC--United-States_title',
    subtitle: 'slug--Charleston--SC--United-States_subtitle',
  },
  {
    slug: 'San-Diego--CA--United-States',
    title: 'slug--San-Diego--CA--United-States_title',
    subtitle: 'slug--San-Diego--CA--United-States_subtitle',
  },
  {
    slug: 'Chicago--IL--United-States',
    title: 'slug--Chicago--IL--United-States_title',
    subtitle: 'slug--Chicago--IL--United-States_subtitle',
  },
  {
    slug: 'New-York--NY--United-States',
    title: 'slug--New-York--NY--United-States_title',
    subtitle: 'slug--New-York--NY--United-States_subtitle',
  },
  {
    slug: 'Nashville--TN--United-States',
    title: 'slug--Nashville--TN--United-States_title',
    subtitle: 'slug--Nashville--TN--United-States_subtitle',
  },
  {
    slug: 'Cabo-San-Lucas--Baja-California-Sur--Mexico',
    title: 'slug--Cabo-San-Lucas--Baja-California-Sur--Mexico_title',
    subtitle: 'slug--Cabo-San-Lucas--Baja-California-Sur--Mexico_subtitle',
  },
  {
    slug: 'Lake-Havasu-City--AZ--United-States',
    title: 'slug--Lake-Havasu-City--AZ--United-States_title',
    subtitle: 'slug--Lake-Havasu-City--AZ--United-States_subtitle',
  },
  {
    slug: 'Marina-Del-Rey--CA--United-States',
    title: 'slug--Marina-Del-Rey--CA--United-States_title',
    subtitle: 'slug--Marina-Del-Rey--CA--United-States_subtitle',
  },
  {
    slug: 'Toronto--Ontario--Canada',
    title: 'slug--Toronto--Ontario--Canada_title',
    subtitle: 'slug--Toronto--Ontario--Canada_subtitle',
  },
];

export default topDestinationSlugs;
